<template>
  <div class="column small-12">
    <label>
      <span>
        {{ $t('tenantProjects.inspection.supportingDocs') }}
      </span>
    </label>
    <HkldDropzone
      v-if="canEdit && inspection.id"
      :sourceId="inspection.id"
      :name="inspection.id"
      :metaData="{ viewInEmail: '', uploadOnTop: true }"
    />
    <EditAttachments
      v-if="inspection.id"
      :uploadOnTop="true"
      :sourceId="inspection.id"
      :canDownloadAll="false"
      :showAllDeleteBtn="false"
      :canDelete="canEdit"
      :canEdit="canEdit"
      :attachmentTypes="attachmentTypes"
      :showDeleteBtnFunc="(item) => !attachmentsInMail.has(item.id)"
      :getFilesList="getFilesList"
      :filesChanged="onChangedFiles"
      :updateDescriptionCb="onChangedFiles"
    />
  </div>
</template>

<script>
import EditAttachments from '@/controls/EditAttachments'
import HkldDropzone from '@/controls/HkldDropzone'
import { useStoreGetters } from '@/store'
import i18n from '@/utils/i18n'
import { computed, ref } from 'vue-demi'
import { useAttachments, useCurrentInspection } from './Provider.vue'
import { useCanUpdateInspection } from './hooks'
import * as inspectionAPI from '@/api/inspection/request'

export default {
  components: {
    EditAttachments,
    HkldDropzone,
  },
  props: {
    mailHistories: {
      type: Array,
      default: () => [],
    },
  },
  setup (props) {
    const inspection = useCurrentInspection()
    const { isTenant } = useStoreGetters('user', ['isTenant'])
    const attachments = useAttachments()
    const attachmentTypes = ref([{
      typeName: i18n.t('tenantProjects.inspection.viewInEmail'),
      attrName: 'viewInEmail',
    }])
    const attachmentsInMail = computed(() => {
      return props.mailHistories.reduce((set, { attachmentList = [] }) => {
        attachmentList.forEach(id => set.add(id))
        return set
      }, new Set())
    })
    const getFilesList = (list) => (attachments.value = list)
    const onChangedFiles = async () => {
      if (!inspection.value.isCreating) {
        await inspectionAPI.updateUpdatedAt(inspection.value.id)
        const result = await inspectionAPI.getById(inspection.value.id)
        Object.assign(inspection.value, { updatedAt: result.updatedAt })
      }
    }
    return {
      inspection,
      onChangedFiles,
      attachmentTypes,
      attachmentsInMail,
      isTenant,
      getFilesList,
      canEdit: useCanUpdateInspection(),
    }
  },
}
</script>

<style lang="scss" scoped>
.column ::v-deep {
  .description {
    width: unset;
  }
  .view-in-email {
    width: 5%;
  }
}
</style>
